/**
 * URL代理工具函数
 * 用于将COS URL转换为代理URL，避免CORS问题
 * 支持图片、视频、音频等所有媒体文件
 */

import { getApiBase } from '../api/client';

/**
 * 判断URL是否为COS URL（需要代理）
 * @param {string} url - 要检查的URL
 * @returns {boolean}
 */
export const isCosUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return url.includes('cos.ap-beijing.myqcloud.com') || 
         url.includes('cos.') || 
         url.includes('myqcloud.com');
};

/**
 * 将COS URL转换为代理URL
 * @param {string} cosUrl - COS URL
 * @returns {string|null} 代理URL或原URL
 */
export const getProxyUrl = (cosUrl) => {
  console.log('[getProxyUrl] 输入URL:', cosUrl);
  if (!cosUrl) {
    console.log('[getProxyUrl] URL为空，返回null');
    return null;
  }

  // 如果是COS URL，转换为代理URL
  if (isCosUrl(cosUrl)) {
    const apiBase = getApiBase();
    const proxyUrl = `${apiBase}/files/proxy?url=${encodeURIComponent(cosUrl)}`;
    console.log('[getProxyUrl] 检测到COS URL，转换为代理URL:', proxyUrl);
    return proxyUrl;
  }

  // 如果是data URL（base64），直接返回
  if (cosUrl.startsWith('data:')) {
    console.log('[getProxyUrl] data URL，直接返回');
    return cosUrl;
  }

  // 其他情况直接返回原URL
  console.log('[getProxyUrl] 普通URL，直接返回');
  return cosUrl;
};

/**
 * 批量转换URL数组
 * @param {string[]|Array} urls - URL数组或对象数组
 * @returns {string[]|Array} 转换后的URL数组
 */
export const getProxyUrls = (urls) => {
  if (!urls || !Array.isArray(urls)) return urls;
  
  return urls.map(item => {
    if (typeof item === 'string') {
      return getProxyUrl(item);
    } else if (item && typeof item === 'object') {
      // 如果是对象，检查是否有src或url属性
      const newItem = { ...item };
      if (newItem.src) {
        newItem.src = getProxyUrl(newItem.src);
      }
      if (newItem.url) {
        newItem.url = getProxyUrl(newItem.url);
      }
      return newItem;
    }
    return item;
  });
};

export default {
  isCosUrl,
  getProxyUrl,
  getProxyUrls
};

